import React from 'react'

import DetachedInvoiceContext from 'contexts/DetachedInvoiceContext'
import useBeforeunload from 'hooks/useBeforeunload'

const DetachedInvoiceProvider = ({ children }) => {
  const [data, setData] = React.useState({ taxes: [] })

  useBeforeunload(() => {
    return 'Sair do site?'
  })

  return (
    <DetachedInvoiceContext.Provider value={{ data, setData }}>
      {children}
    </DetachedInvoiceContext.Provider>
  )
}

export default DetachedInvoiceProvider
